import { postRequests } from '@/service/requests';

async function postToReport(url, data, config) {
  try {
    const response = postRequests(
      `${self.settings.webVitalsUrl}`,
      self.composePayload(metric),
      {
        keepalive: true
      }
    );
    return response;
  } catch (e) {
    console.log('error =>', e);
    return { error: e };
  }
}

export { postToReport };
